var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStreak4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 43.5148C58.5 57.2384 47.1355 68.2765 33.4127 67.4572C19.3083 66.6151 9.6507 53.0507 11.4699 38.8721C12.5704 30.2465 16.6131 22.8499 21.0152 17.1146C21.7788 16.1132 22.5648 24.1699 23.3509 23.2823C24.1371 22.3719 31.4363 9.74076 33.9743 5.30277C34.4459 4.48346 35.5239 4.23312 36.2875 4.82485C41.3858 8.67109 58.5 23.123 58.5 43.5148Z",
    fill: "#007E7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.75 49.1652C51.75 58.2593 43.8327 65.5695 34.2025 65.2392C23.8084 64.8868 16.6782 55.3745 18.2061 45.576C20.4053 31.5279 34.8275 22.5 34.8275 22.5C34.8275 22.5 51.75 33.0912 51.75 49.1652Z",
    fill: "#20BCBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9233 53.3275V48.499L34.4185 31.9619H38.7092V38.5167H36.2198L30.0778 48.2488V48.4489H45.2765V53.3275H23.9233ZM36.2949 57.5806V51.8514L36.42 49.7374V31.9619H42.2117V57.5806H36.2949Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreak4);
export default __webpack_public_path__ + "static/media/streak-4.12209fa92dcc3bc7116578e734d9fb21.svg";
export { ForwardRef as ReactComponent };